<div class="login-borraccia">
    <div class="section">
        <div style="text-align: center;margin-top: 7px;margin-bottom: 170px;">
            <span class="image-preview" style="background-size: cover;"
                [ngStyle]="{'background-image': 'url(' + bottleURL + ')'}">
            </span>
        </div>
        <div class="container" style="padding-top: 100px;">
            <p style=" border-top: 1px solid #CECECE; margin-top: 2px;margin-bottom: 25px;"></p>
            <p class="boxSummary">
                <span>{{ 'color_bottle' | translate }}</span>
                <span class="color">
                    <span class="color-dot"
                        [ngStyle]="{'background-color': configurationModel.water_bottle_color_hex}"></span>
                    <span class="color-text">{{colorBottleName}}</span>
                </span>
            </p>
        </div>
        <div class="container ">
            <p class="boxSummary">
                <span>{{ capName }}</span>
                <span class="color">
                    <span class="color-dot" [ngStyle]="{'background-color': configurationModel.cap_color_hex}"></span>
                    <span class="color-text">{{colorCapName}}</span>
                </span>
            </p>
        </div>
        <div class="container ">
            <p class="boxSummary">
                <span>{{ valveName }}</span>
                <span class="color">
                    <span class="color-dot" [ngStyle]="{'background-color': configurationModel.valve_color_hex}"></span>
                    <span class="color-text">{{colorValveName}}</span>
                </span>
            </p>
        </div>
        <div class="container ">
            <p class="boxSummary">
                <span>{{ 'capacity_bottle' | translate }}</span>
                <span class="color">
                    <span class="color-text">{{configurationModel.water_bottle_capacity}}ml</span>
                </span>
            </p>
        </div>
        <div class="container ">
            <p class="boxSummary">
                <span>{{ 'quantity_order' | translate }}</span>
                <span class="color">
                    <span class="color-text">{{configurationModel.quantity}}pz</span>
                </span>
            </p>
        </div>
        <div *ngIf="configurationModel.price" class="container ">
            <p class="boxSummary">
                <span>{{ 'order_price' | translate }}</span>
                <span class="color">
                    <span class="color-text">{{ getOrderPrice() }}€</span>
                </span>
            </p>
        </div>
    </div>
    <div class="login-borraccia-top">

    </div>

</div>

<div class="section">
    <form #f="ngForm" (ngSubmit)="sendRequest()">
        <div class="container is-fluid register">
            <p>{{ configurationModel.price ? ('order_request_title' | translate) : ('quotation_request_title' | translate) }} <img src="/assets/img/red_dot.png"></p>
        </div>
        <div class="container is-fluid register-subtitle">
            <p>{{ 'quotation_request_subtitle_first' | translate }} {{firstName}}!</p>
        </div>
        <div class="container is-fluid register-subtitle">
            <p>{{ configurationModel.price ? ('order_request_subtitle_second' | translate) : ('quotation_request_subtitle_second' | translate) }}</p>
        </div>
        <div class="container is-fluid register-form">

            <div class="columns is-gapless">
                <div class="column is-6">
                    <div class="columns is-multiline">
                        <div class="column">
                            <div class="field">
                                <p>
                                    <input type="checkbox" id="companyCheckbox" (click)="clickCompanyCheckbox()" style="display: none;" />
                                    <label for="companyCheckbox">
                                        <img *ngIf="!formIsCompany" src="/assets/img/unchecked.png">
                                        <img *ngIf="formIsCompany" src="/assets/img/checked.png"> 
                                    </label>
                                    {{ 'quotation.company' | translate }}
                                </p>
                                <p>
                                    <input type="checkbox" id="privateCheckbox" (click)="clickPrivateCheckbox()" style="display: none;" />
                                    <label for="privateCheckbox">
                                        <img *ngIf="formIsCompany" src="/assets/img/unchecked.png">
                                        <img *ngIf="!formIsCompany" src="/assets/img/checked.png"> 
                                    </label>
                                    {{ 'quotation.private' | translate }}
                                </p>
                            </div>
                        </div>

                        <div class="column is-half mobile-hidden">
                        </div>

                        <!-- Company name -->
                        <div class="column is-full" *ngIf="formIsCompany">
                            <div class="field">
                                <label class="label">{{ 'quotation.company_name' | translate }}</label>
                                <div class="control">
                                    <input class="input" type="text" [(ngModel)]="quotationModel.company_name" required name="company_name">
                                </div>
                            </div>
                        </div>

                        <!-- First name and last name -->
                        <div class="column is-half" *ngIf="!formIsCompany">
                            <div class="field">
                                <label class="label">{{ 'quotation.first_name' | translate }}</label>
                                <div class="control">
                                    <input class="input" type="text" [(ngModel)]="quotationModel.name" required name="first_name">
                                </div>
                            </div>
                        </div>

                        <div class="column is-half" *ngIf="!formIsCompany">
                            <div class="field">
                                <label class="label">{{ 'quotation.last_name' | translate }}</label>
                                <div class="control">
                                    <input class="input" type="text" [(ngModel)]="quotationModel.surname" required name="last_name">
                                </div>
                            </div>
                        </div>

                        <!-- Email and phone -->
                        <div class="column is-half">
                            <div class="field">
                                <label class="label">{{ 'quotation.email' | translate }}</label>
                                <div class="control">
                                    <input class="input" type="email" [(ngModel)]="quotationModel.email" required name="email">
                                </div>
                            </div>
                        </div>

                        <div class="column is-half">
                            <div class="field">
                                <label class="label">{{ 'quotation.phone' | translate }}</label>
                                <div class="control">
                                    <input class="input" type="tel" [(ngModel)]="quotationModel.phone_number" required name="phone">
                                </div>
                            </div>
                        </div>

                        <!-- Address -->
                        <div class="column is-half">
                            <div class="field">
                                <label class="label">{{ 'quotation.address' | translate }}</label>
                                <div class="control">
                                    <input class="input" type="text" [(ngModel)]="quotationModel.address" required name="address">
                                </div>
                            </div>
                        </div>

                        <div class="column is-one-quarter">
                            <div class="field">
                                <label class="label">{{ 'quotation.civic_number' | translate }}</label>
                                <div class="control">
                                    <input class="input" type="text" [(ngModel)]="quotationModel.civic_number" required name="civic_number">
                                </div>
                            </div>
                        </div>

                        <div class="column is-one-quarter">
                            <div class="field">
                                <label class="label">{{ 'quotation.zip_code' | translate }}</label>
                                <div class="control">
                                    <input class="input" type="text" [(ngModel)]="quotationModel.zip_code" required name="zip_code">
                                </div>
                            </div>
                        </div>

                        <!-- City and country -->
                        <div class="column is-half">
                            <div class="field">
                                <label class="label">{{ 'quotation.city' | translate }}</label>
                                <div class="control">
                                    <input class="input" type="text" [(ngModel)]="quotationModel.city" required name="city">
                                </div>
                            </div>
                        </div>

                        <div class="column is-half">
                            <div class="field">
                                <label class="label">{{ 'quotation.country' | translate }}</label>
                                <div class="select is-small">
                                    <select [(ngModel)]="country" name="country">
                                        <option *ngFor="let country of countries" [ngValue]="country.code">{{ country.name }}</option>
                                    </select>
                                </div>
                            </div>
                        </div>

                        <!-- VAT Number -->
                        <div class="column is-half" *ngIf="formIsCompany">
                            <div class="field">
                                <label class="label">{{ 'quotation.vat_number' | translate }}</label>
                                <div class="control">
                                    <input class="input" type="text" [(ngModel)]="quotationModel.vat_number" required name="vat_number">
                                </div>
                            </div>
                        </div>

                        <div class="column is-half mobile-hidden" *ngIf="formIsCompany">
                        </div>

                        <!-- Fiscal code and SDI code -->
                        <div class="column is-half" *ngIf="country == 'IT'">
                            <div class="field">
                                <label class="label">{{ 'quotation.fiscal_code' | translate }}</label>
                                <div class="control">
                                    <input class="input" type="text" [(ngModel)]="quotationModel.fiscal_code" required name="fiscal_code">
                                </div>
                            </div>
                        </div>

                        <div class="column is-half mobile-hidden" *ngIf="!formIsCompany && country == 'IT'">
                        </div>

                        <div class="column is-half" *ngIf="formIsCompany && country == 'IT'">
                            <div class="field">
                                <label class="label">{{ 'quotation.sdi_code' | translate }}</label>
                                <div class="control">
                                    <input class="input" type="text" [(ngModel)]="quotationModel.sdi_code" required name="sdi_code">
                                </div>
                            </div>
                        </div>

                        <!-- Alternative address -->
                        <div class="column is-full">
                            <div class="field">
                                <label class="label">{{ 'quotation.address_question' | translate }}</label>
                                <p>
                                    <input type="checkbox" id="sameAddressCheckbox" (click)="clickSameAddressCheckbox()" style="display: none;" />
                                    <label for="sameAddressCheckbox">
                                        <img *ngIf="quotationModel.different_delivery_address" src="/assets/img/unchecked.png">
                                        <img *ngIf="!quotationModel.different_delivery_address" src="/assets/img/checked.png"> 
                                    </label>
                                    {{ 'quotation.address_question_yes' | translate }}
                                </p>
                                <p>
                                    <input type="checkbox" id="differentAddressCheckbox" (click)="clickDifferentAddressCheckbox()" style="display: none;" />
                                    <label for="differentAddressCheckbox">
                                        <img *ngIf="!quotationModel.different_delivery_address" src="/assets/img/unchecked.png">
                                        <img *ngIf="quotationModel.different_delivery_address" src="/assets/img/checked.png"> 
                                    </label>
                                    {{ 'quotation.address_question_no' | translate }}
                                </p>
                            </div>
                        </div>

                        <!-- Destination name -->
                        <div class="column is-full" *ngIf="quotationModel.different_delivery_address">
                            <div class="field">
                                <label class="label">{{ 'quotation.delivery_name' | translate }}</label>
                                <div class="control">
                                    <input class="input" type="text" [(ngModel)]="quotationModel.delivery_name" required name="delivery_name">
                                </div>
                            </div>
                        </div>

                        <!-- Alternative address -->
                        <div class="column is-half" *ngIf="quotationModel.different_delivery_address">
                            <div class="field">
                                <label class="label">{{ 'quotation.address' | translate }}</label>
                                <div class="control">
                                    <input class="input" type="text" [(ngModel)]="quotationModel.delivery_address" required name="delivery_address">
                                </div>
                            </div>
                        </div>

                        <div class="column is-one-quarter" *ngIf="quotationModel.different_delivery_address">
                            <div class="field">
                                <label class="label">{{ 'quotation.civic_number' | translate }}</label>
                                <div class="control">
                                    <input class="input" type="text" [(ngModel)]="quotationModel.delivery_civic_number" required name="delivery_civic_number">
                                </div>
                            </div>
                        </div>

                        <div class="column is-one-quarter" *ngIf="quotationModel.different_delivery_address">
                            <div class="field">
                                <label class="label">{{ 'quotation.zip_code' | translate }}</label>
                                <div class="control">
                                    <input class="input" type="text" [(ngModel)]="quotationModel.delivery_zip_code" required name="delivery_zip_code">
                                </div>
                            </div>
                        </div>

                        <!-- Alternative city and country -->
                        <div class="column is-half" *ngIf="quotationModel.different_delivery_address">
                            <div class="field">
                                <label class="label">{{ 'quotation.city' | translate }}</label>
                                <div class="control">
                                    <input class="input" type="text" [(ngModel)]="quotationModel.delivery_city" required name="delivery_city">
                                </div>
                            </div>
                        </div>

                        <div class="column is-half" *ngIf="quotationModel.different_delivery_address">
                            <div class="field">
                                <label class="label">{{ 'quotation.country' | translate }}</label>
                                <div class="select is-small">
                                    <select [(ngModel)]="delivery_country" name="delivery_country">
                                        <option *ngFor="let country of countries" [ngValue]="country.code">{{ country.name }}</option>
                                    </select>
                                </div>
                            </div>
                        </div>

                        <!-- Purpose -->
                         <div class="column is-full">
                            <div class="field">
                                <label class="label">{{ 'quotation.purpose' | translate }}</label>
                                <div class="select is-small">
                                    <select [(ngModel)]="usage_type" name="usage_type">
                                        <option value="0">{{ 'quotation.purpose_0' | translate }}</option>
                                        <option value="1">{{ 'quotation.purpose_1' | translate }}</option>
                                        <option value="2">{{ 'quotation.purpose_2' | translate }}</option>
                                        <option value="3">{{ 'quotation.purpose_3' | translate }}</option>
                                        <option value="4">{{ 'quotation.purpose_4' | translate }}</option>
                                        <option value="5">{{ 'quotation.purpose_5' | translate }}</option>
                                    </select>
                                </div>
                            </div>
                        </div>

                        <div class="column is-full">
                            <div class="field messagge">
                                <label class="label">{{ 'quotation_form_notes' | translate }}</label>
                                <div class="control">
                                    <textarea class="textarea" type="text" rows="5" style="background-color: #F0F3F3;"
                                        [(ngModel)]="quotationModel.notes" name="notes"></textarea>
                                </div>
                            </div>
                        </div>

                        <!-- Disclaimer -->
                        <div class="column is-full">
                            <div class="field">
                                <p>
                                    <input type="checkbox" id="disclaimerCheckbox" (click)="clickDisclaimerCheckbox()" style="display: none;" />
                                    <label for="disclaimerCheckbox">
                                        <img *ngIf="!disclaimer" src="/assets/img/unchecked.png">
                                        <img *ngIf="disclaimer" src="/assets/img/checked.png"> 
                                    </label>
                                    {{ 'quotation.disclaimer' | translate }} <a href="https://com-elite-repository.s3.eu-west-1.amazonaws.com/customized_bottles.pdf" target="_blank"><u>link</u></a>
                                </p>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>

        <div class="column is-6">
            <div class="field">
                <div class="control submit ">
                    <button type="submit" style="background-color: #E2001A;" [disabled]="f.form.invalid"
                        class="button is-primary is-fullwidth">{{'send_request' | translate}}</button>
                </div>
            </div>
        </div>

    </form>
</div>